import React from "react";
import OuterHeader from "./../ui/outer-header";
import useAuth from "./../context/auth";
import mohammad_image from "./../assets/images/mohammad.jpg";
import { RESUME_API } from "./../assets/data/api";
import { gold_color, gradient_primary, gradient_primary_gold } from "./../assets/data/colors";
import { developer_mail } from "../assets/data/general";

// the tags of the developer
const tags = ["Web Development", "Mobile Apps", "UI / UX Design", "Embedded Systems", "Ethical Hacking", "Dentistry"];

// the developer page
const Developer = () => {
    const { auth } = useAuth();

    return (
        <div>
            {!auth && <OuterHeader />}
            <div className=" max-w-5xl mx-auto mt-10 sm:mt-16 px-4 sm:px-6">
                <div className="rounded-2xl overflow-visible border border-gray-200 dark:border-gray-700 bg-white/80 dark:bg-[#0d1117]/80 backdrop-blur-md shadow-[0_10px_40px_rgba(0,0,0,0.08)]">
                    <div className="h-24 sm:h-28 rounded-t-2xl relative" style={{ background: gradient_primary }}>
                        <div className="absolute bottom-0 left-0 right-0 h-1" style={{ background: gradient_primary_gold }} />
                        <div className="absolute -bottom-10 sm:-bottom-12 left-6 sm:left-10">
                            <img src={mohammad_image} alt="Dr. Mohammad Sherzad Aziz" className="w-20 h-20 sm:w-24 sm:h-24 rounded-full object-cover border-4 border-white dark:border-[#0d1117] shadow-md" />
                        </div>
                    </div>
                    <div className="pt-14 sm:pt-16 px-5 sm:px-10 pb-6 sm:pb-8">
                        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white leading-tight">Dr. Mohammad Sherzad Abdulaziz</h1>
                        <p className="text-[11px] sm:text-sm font-medium tracking-[2px] sm:tracking-widest uppercase mt-1 mb-4 sm:mb-5" style={{ color: gold_color }}>Dentist &amp; Full-Stack Developer</p>
                        <hr className="border-gray-300 dark:border-gray-700 mb-5" />
                        <p className="text-justify text-base sm:text-[16px] text-gray-700 dark:text-gray-400 leading-relaxed mb-6">Dentist from the University of Duhok, driven by a deep passion for building digital experiences. From full-stack web platforms and mobile interfaces to embedded systems and ethical hacking — seamlessly blending the precision of medicine with the innovation of technology.</p>

                        <div className="flex flex-wrap gap-2 mb-7">
                            {tags.map(tag => (
                                <span key={tag} className="text-xs font-medium px-3 py-1 rounded-full bg-gray-100/70 dark:bg-white/5 border border-transparent text-gray-600 dark:text-gray-400">
                                    {tag}
                                </span>
                            ))}
                        </div>
                        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                            <a href={RESUME_API + "mohammad.pdf"} target="_blank" rel="noreferrer" download className="transition-opacity duration-100 hover:opacity-90 text-center w-full sm:w-auto text-md sm:text-md font-medium px-6 py-3 rounded-xl text-white shadow-[0_6px_20px_rgba(0,0,0,0.15)]" style={{ background: gradient_primary, color: "#fff" }}>View Resume</a>
                            <a href={`mailto:${developer_mail}`} className="text-center w-full sm:w-auto text-sm sm:text-md font-medium px-6 py-3 rounded-xl border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300 bg-white/60 dark:bg-white/5 backdrop-blur-md">Get in Touch</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Developer;